import { Skeleton } from './skeleton'

/**
 * Skeleton that matches the Dropdown component exactly.
 * Uses invisible text to ensure dimensions match the actual content.
 */
export function DropdownSkeleton() {
  return (
    <div className="relative flex flex-col justify-between px-3 py-2 md:px-4 md:py-3 rounded-xl bg-white/[0.03] min-w-[140px] w-full h-full">
      {/* Top row: Label + Chevron - matches dropdown button structure */}
      <div className="flex items-center justify-between">
        <span className="text-xs text-transparent">Model</span>
        <Skeleton className="size-4 rounded" />
      </div>
      {/* Value row with icon - matches dropdown button structure */}
      <div className="flex items-center gap-2">
        <Skeleton className="hidden md:block size-4 rounded" />
        <span className="text-sm text-transparent">Standard</span>
      </div>
    </div>
  )
}

/**
 * Skeleton that matches the DurationSelector component exactly.
 * Uses flex-1 buttons to match the actual button layout.
 */
export function DurationSkeleton() {
  return (
    <div className="flex flex-col rounded-xl bg-white/[0.03] px-3 py-2 md:px-4 md:py-3 h-full">
      <span className="text-xs text-transparent">Duration</span>
      <div className="relative flex gap-1 mt-auto">
        {/* Use flex-1 like the actual buttons do */}
        <Skeleton className="flex-1 h-[26px] rounded-md" />
        <Skeleton className="flex-1 h-[26px] rounded-md" />
      </div>
    </div>
  )
}
